import React from 'react';

import { useFormikContext } from 'formik';

import { Typography } from 'homer-web-app-components';

import classNames from 'classnames';

import { LANGUAGES, LANGUAGES_NAMES } from '../../../../../constants/languages';
import { TIP_PION_TYPES } from '../../../../../constants/tasks';
import { Tile, TileHeader, TileMain } from '../../../../Common';
import MutateIntercom from '../../../../Common/MutateAction/MutateIntercom';
import Errors from '../../../Errors';
import PushTask from '../../../PushTask';

import MutateTipPionActionType from './MutateTipPionActionType';
import MutateTipPionContent from './MutateTipPionContent';
import MutateTipPionFile from './MutateTipPionFile';
import MutateTipPionLegend from './MutateTipPionLegend';
import MutateTipPionTitle from './MutateTipPionTitle';
import MutateTipPionToScreen from './MutateTipPionToScreen';
import MutateTipPionUrl from './MutateTipPionUrl';

const IMAGE_MIME_TYPES = {
  PNG: 'image/png',
  JPG: 'image/jpg',
  JPEG: 'image/jpeg',
  BMP: 'image/bmp',
  TIFF: 'image/tiff',
  WEBP: 'image/webp',
};

const MutateTipPion = () => {
  const { values, errors, setFieldValue, setFieldTouched } = useFormikContext();

  return (
    <>
      {Object.keys(errors).length > 0 && <Errors errors={errors} />}
      <Tile theme={Tile.THEME.WHITE}>
        <TileHeader
          style={{ marginBottom: '4rem', display: 'flex' }} // @todo Move `marginBottom` to an util css
        >
          <Typography
            component="h2"
            variant={Typography.THEME.VARIANTS.TITLE_HUGE}
          >
            Entry
          </Typography>
          {values.id && <PushTask />}
        </TileHeader>
        <TileMain style={{ padding: 0 }}>
          {Object.values(LANGUAGES).map((language) => (
            <React.Fragment key={language}>
              <MutateTipPionLegend
                className={classNames({
                  'mutate-tip-pion-legend-error':
                    !values.data.payload.title[language] ||
                    (values.data.payload.title[language] &&
                      errors['payload.title']) ||
                    !values.data.payload.content[language] ||
                    (values.data.payload.content[language] &&
                      errors['payload.content']),
                })}
              >
                {LANGUAGES_NAMES[language]}
              </MutateTipPionLegend>
              <MutateTipPionTitle
                style={{ marginBottom: '.5rem' }}
                name={`data.payload.title.${language}`}
                data-testid={`data.payload.title.${language}`}
              />
              <MutateTipPionContent
                style={{ marginBottom: '.875rem' }}
                name={`data.payload.content.${language}`}
                data-testid={`data.payload.content.${language}`}
              />
              <MutateTipPionFile
                style={{ marginBottom: '1rem' }}
                language={language}
                type={Object.values(IMAGE_MIME_TYPES)}
                name={`data.payload.file.${language}`}
                data-testid={`data.payload.file.${language}`}
                onSubmit={(value) => {
                  Object.values(LANGUAGES)
                    .filter((l) => l !== language)
                    .forEach((l) => {
                      if (!values.data.payload.file[l]) {
                        setFieldValue(`data.payload.file.${l}`, value);
                        setFieldTouched(`data.payload.file.${l}`, true);
                      }
                    });
                }}
              />
            </React.Fragment>
          ))}
        </TileMain>
      </Tile>
      <Tile theme={Tile.THEME.GIN}>
        <TileHeader
          style={{ marginBottom: '1.5rem' }} // @todo Move `marginBottom` to an util css
        >
          <Typography
            component="h2"
            variant={Typography.THEME.VARIANTS.TITLE_HUGE}
          >
            Action
          </Typography>
        </TileHeader>
        <TileMain style={{ padding: 0 }}>
          <MutateTipPionActionType
            style={{
              marginLeft: '.5rem',
              marginRight: '.5rem',
              marginBottom: '1rem',
            }}
            name="data.payload.actionType"
            data-testid="data.payload.actionType"
          />
          {values.data.payload.actionType === TIP_PION_TYPES.URL &&
            Object.values(LANGUAGES).map((language) => (
              <React.Fragment key={language}>
                <MutateTipPionLegend
                  className={classNames('mutate-tip-pion-legend', {
                    'mutate-tip-pion-legend-error':
                      (values.data.payload.actionType === TIP_PION_TYPES.URL &&
                        !values.data.payload.url[language]) ||
                      errors['payload.url'],
                  })}
                >
                  {LANGUAGES_NAMES[language]}
                </MutateTipPionLegend>
                <MutateTipPionUrl
                  style={{
                    marginLeft: '.5rem',
                    marginRight: '.5rem',
                    marginBottom: '1rem',
                    width: 'calc(100% - 1rem)',
                  }}
                  name={`data.payload.url.${language}`}
                  data-testid={`data.payload.url.${language}`}
                />
              </React.Fragment>
            ))}
          {/** @todo Make multilang */}
          {values.data.payload.actionType === TIP_PION_TYPES.NAVIGATION && (
            <MutateTipPionToScreen
              style={{
                marginLeft: '.5rem',
                marginRight: '.5rem',
                marginBottom: '1rem',
                width: 'calc(100% - 1rem)',
              }}
              name="data.payload.toScreen"
              data-testid="data.payload.toScreen"
            />
          )}
          {values.data.payload.actionType === TIP_PION_TYPES.INTERCOM && (
            <MutateIntercom
              style={{
                marginLeft: '.5rem',
                marginRight: '.5rem',
                marginBottom: '1rem',
                width: 'calc(100% - 1rem)',
              }}
              name="data.payload.intercom"
              data-testid="data.payload.intercom"
            />
          )}
        </TileMain>
      </Tile>
    </>
  );
};

export default MutateTipPion;
